import React from 'react'

import i18n from 'i18n-literally'

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box } from '@mui/material'

import createLogger from '~/src/Lib/Logging'
import T from '~/src/UI/Shared/Typography'

const displayName = 'SuccessGateway'
const logger = createLogger(displayName)

const Sucees = () => (
  <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap="2rem">
    <CheckCircleIcon sx={{ width: 50, height: 50 }} color="success" />
    <Box textAlign="center">
      <T.H2>{i18n`Success!`}</T.H2>
      <T>{i18n`Your account is created.`}</T>
    </Box>
    <Box maxWidth={550} textAlign="center" display="flex" flexDirection="column">
      <T>{i18n`We just sent a verification link to your email address.`}</T>
      <T.Body.Bold>{i18n`Please open your email and follow the link to begin using AROYA.`}</T.Body.Bold>
    </Box>

    <T maxWidth={500} textAlign="center">
      {i18n`The link is valid for the next 24 hours.`}
    </T>
  </Box>
)

const Memoized = React.memo(Sucees)
export default Memoized
